function customError(errCode: string, message: string = "", ctx?: Object) {
  let formattedCtx = ""
  if (ctx) {
    formattedCtx = JSON.stringify(ctx, null, "\t")
      .replace(/[",\{\}]/g, "")
      .replace("errorContext", "ERROR DETAILS")
  }

  const formattedMessage =
    `Code ${errCode}.\nMessage: ${message}\n${formattedCtx ? `${formattedCtx}` : ""}`.trim()

  throw new Error(formattedMessage)
}

function _errMissing(errCode: string, what: any, ctx: any) {
  return customError(errCode, `Missing ${what}.`, ctx)
}

function _errUnexpected(
  errCode: string,
  name: string,
  expected: string | number,
  got: string | number,
  ctx: Object,
  comparisonGroup?: string
) {
  return customError(
    errCode,
    `Unexpected ${name} ${comparisonGroup}.\nExpected: ${expected}, Got: ${got}.`,
    ctx
  )
}

export { _errMissing, _errUnexpected, customError }
